var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C7.7593 12 7.53265 11.8889 7.38823 11.7L1.74585 4.32149C1.64521 4.18989 1.73905 4 1.90472 4H3.2141C3.33869 4 3.45616 4.05805 3.53184 4.15702L8 10L12.4682 4.15702C12.5438 4.05805 12.6613 4 12.7859 4H14.0953C14.261 4 14.3548 4.18989 14.2542 4.32149L8.61176 11.7C8.46735 11.8889 8.2407 12 8 12Z",
    fill: "#DEE2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.7b36369233e0fffc677e89dcc3e2a1da.svg";
export { ForwardRef as ReactComponent };